import React, { useState } from 'react';
import InnerPageLayout from '../components/ui/InnerPageLayout';
import Accordion from '../components/ui/Accordion';
import PageSEO from '../components/legal/PageSEO';
import SummaryCards from '../components/legal/SummaryCards';
import SectionHeading from '../components/legal/SectionHeading';
import ContactCTA from '../components/legal/ContactCTA';
import {
  TERMS_SUMMARY_CARDS,
  TERMS_SECTIONS,
  TERMS_LAST_UPDATED,
} from '../content/termsContent';

function Terms() {
  const [openSection, setOpenSection] = useState(0);

  return (
    <InnerPageLayout
      tag="Community • Safety • Plain Language"
      title="User"
      titleAccent="Agreement"
      description="By using StrapIn, you agree to the community rules, privacy expectations, safety investigations, and responsible behavior described below."
      wide
    >
      <PageSEO
        title="StrapIn User Agreement and Terms of Service"
        description="StrapIn User Agreement — community rules, verification, privacy, consent, safety evidence, fraud investigations, and moderation."
        path="/terms"
      />

      <p className="-mt-8 mb-12 text-center text-xs text-silver">
        Last updated: {TERMS_LAST_UPDATED}
      </p>

      <section className="mb-16">
        <SectionHeading
          tag="At a glance"
          title="The Essentials"
          description="Eight principles that guide how we keep StrapIn respectful, adult, and safer for queer connection."
        />
        <SummaryCards items={TERMS_SUMMARY_CARDS} columns="sm:grid-cols-2 xl:grid-cols-4" />
      </section>

      <section id="terms-details" className="mb-16">
        <SectionHeading
          tag="Full terms"
          title="Your Agreement With StrapIn"
          description="Expand any section to understand your responsibilities, our safety processes, and your privacy rights."
        />
        <Accordion items={TERMS_SECTIONS} openIndex={openSection} onToggle={setOpenSection} />
      </section>

      <ContactCTA
        icon="✉️"
        title="Questions About These Terms?"
        description="Reach out if something is unclear. We would rather explain than confuse."
        emails={[
          { label: 'terms@strapinapp.com', href: 'mailto:terms@strapinapp.com' },
          { label: 'support@strapinapp.com', href: 'mailto:support@strapinapp.com' },
        ]}
        links={[
          { label: 'Privacy Policy', to: '/privacy' },
          { label: 'Safety Center', to: '/safety' },
        ]}
      />
    </InnerPageLayout>
  );
}

export default Terms;
